import {
  AddIcon,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  SelectField,
} from '@all-manager/design-system-v2';
import CreateEditDocumentTypeModal from '../CreateEditDocumentTypeModal/CreateEditDocumentTypeModal';
import useDocumentTypeSelect, { CREATE_NEW_VALUE, type Props } from './useDocumentTypeSelect';

export default function DocumentTypeSelect(props: Props) {
  const {
    documentTypes,
    isCreateModalOpen,
    spaceId,
    isAdmin,
    handleOpenCreateModal,
    handleSelectChange,
    handleCloseCreateModal,
    handleTypeCreated,
  } = useDocumentTypeSelect(props);

  const selectedType = documentTypes.find(
    (type) => type.id === props.value || type.name === props.value
  );
  const selectValue = selectedType ? selectedType.id : (props.value ?? '');
  const isUnknownValue = selectValue !== '' && !documentTypes.some((type) => type.id === selectValue);

  return (
    <>
      <SelectField<string>
        label={props.label ?? 'Type'}
        value={selectValue}
        onChange={handleSelectChange}
        size={props.size ?? 'small'}
        fullWidth={props.fullWidth}
        error={props.error}
        disabled={props.disabled}
        helperText={props.helperText}
      >
        {documentTypes.map((type) => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
        {isUnknownValue ? (
          // Keeps a legacy or still-loading value selectable instead of rendering an empty field.
          <MenuItem value={selectValue} disabled>
            {selectValue}
          </MenuItem>
        ) : null}
        {isAdmin && documentTypes.length > 0 ? <Divider /> : null}
        {isAdmin ? (
          <MenuItem value={CREATE_NEW_VALUE} onClick={handleOpenCreateModal}>
            <ListItemIcon>
              <AddIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Créer un nouveau type" />
          </MenuItem>
        ) : null}
      </SelectField>

      {isCreateModalOpen && spaceId ? (
        <CreateEditDocumentTypeModal
          spaceId={spaceId}
          onClose={handleCloseCreateModal}
          onSuccess={handleTypeCreated}
        />
      ) : null}
    </>
  );
}
